import Chart from 'chart.js';

// https://stackoverflow.com/questions/21646738/convert-hex-to-rgba
function hexToRgbA(hex, alpha){
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+alpha+')';
    }
    throw new Error('Bad Hex');
}

// hexToRgbA('#fbafff')


document.addEventListener("turbolinks:load", () => {

  // Conteggio biglietti disponibili, prenotati e venduti
  // /events/1/tickets
  var $tickets = $('#tickets_cake');
  if ($tickets.length) {
    let data = $tickets.data('dt');
    let bgColors = $.map(data.colors, function(n,i){
      return (hexToRgbA(n, 0.3));
    });

    var myChart = new Chart($tickets, {
        type: 'doughnut',
        data: {
            labels: data.labels,
            datasets: [{
                data: data.values,
                backgroundColor: bgColors,
                borderColor: data.colors
            }]
        }
    });
  }

  var ticketsSoldOptions = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
            display: false,
        },
        layout: {
            padding: {
                left: 4,
                right: 4,
                top: 10,
                bottom: 10
            }
        },
        scales: {
            xAxes: [{
                gridLines: {
                    display: false,
                    drawBorder: false,
                },
                ticks: {
                    display: false
                }
            }],
            yAxes: [{
                gridLines: {
                    display: false,
                    drawBorder: false,
                },
                ticks: {
                    display: false
                }
            }],
        }
    }


    const ticketsSelectors = ['#tickets_sold_last24h', '#tickets_sold_last7d', '#tickets_sold_last30d']
    ticketsSelectors.forEach(function(element){ 
          var $t = $(element);
          if ($t.length) {
            let data = $t.data('dt');

            let n=data.length, i=0, a=Array(n);
            while(i<n) a[i++]=i;

            // console.log(data);
            var myChart = new Chart($t, {
                type: 'line',
                data: {
                    labels: a,
                    datasets: [{
                        data: data,
                        fill: false,
                        backgroundColor: 'rgba(256, 256, 256, 0.4)',
                        borderColor: 'rgba(256, 256, 256, 0.4)',
                        pointRadius: 0,
                    }],
                },
                options: ticketsSoldOptions
            });
          }
    })


  // var $tickets24 = $('#tickets_sold_last24h');
  // if ($tickets24.length) {
  //   let data = $tickets24.data('dt');

  //   let n=data.length, i=0, a=Array(n);
  //   while(i<n) a[i++]=i;

  //   console.log(data);
  //   var myChart = new Chart($tickets24, {
  //       type: 'line',
  //       data: {
  //           labels: a,
  //           datasets: [{
  //               data: data,
  //               fill: false,
  //               backgroundColor: 'rgba(256, 256, 256, 0.4)',
  //               borderColor: 'rgba(256, 256, 256, 0.4)'
  //           }]
  //       },
  //       options: ticketsSoldOptions
  //   });
  // }


})
